import {useNavigate} from 'react-router-dom';
import clsx from 'clsx';
import {SoopChip} from '@soop-ui/soop-ui';
import {useGetRecommendKeyword} from '@/hooks/help';
import {sendHelpClickLog} from '@/utils/help/log';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import styles from './RecommendKeyword.module.scss';

interface RecommendKeywordProps {
  align?: 'left' | 'center';
}

const RecommendKeyword = ({align = 'center'}: RecommendKeywordProps) => {
  const navigate = useNavigate();
  const {data: recommendKeyword} = useGetRecommendKeyword();

  const handleKeywordClick = (keyword: string) => {
    navigate(`${ROUTE.HELP.SEARCH}?q=${keyword}`);
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_CONTENTS, {
      buttonType: HELP_LOG.BUTTON_TYPE.KEYWORD,
      text: keyword,
    });
  };

  return (
    <div
      className={clsx(styles.RecommendKeywordList, {
        [styles.left]: align === 'left',
      })}>
      <div>
        <ul>
          {recommendKeyword &&
            recommendKeyword.slice(0, 6).map((keyword) => (
              <li key={keyword}>
                <SoopChip
                  color='primary'
                  size='mobile'
                  onClick={() => handleKeywordClick(keyword)}>
                  {keyword}
                </SoopChip>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default RecommendKeyword;
